/* euroguard · Cabecera «cristal» (sections/eg-header.liquid)
   - Estado de desplazamiento: .is-scrolled (cristal + sombra) y .is-hidden (se esconde al bajar, vuelve al subir).
   - Menús desplegables y ventanas de país / idioma: hover con intención + clic, Escape y clic fuera los cierran.
   - Cajón móvil: abre/cierra con foco, bloquea el scroll del documento.
   - País e idioma: rellena el formulario de localización de Shopify y lo envía.
   - Editor de temas: se reinicia con shopify:section:load. */
(function () {
  'use strict';
  if (window.__egHeader) return;
  window.__egHeader = true;

  var SCROLL_ON = 8;      // px a partir de los que la barra pasa a cristal
  var HIDE_AFTER = 240;   // px a partir de los que puede esconderse
  var DELTA = 6;          // tolerancia para detectar la dirección
  var HOVER_IN = 90, HOVER_OUT = 180;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initHeader(header) {
    if (header.dataset.egReady) return;
    header.dataset.egReady = '1';
    var section = header.closest('.shopify-section') || header.parentElement;
    var drawer = section ? $('[data-eg-drawer]', section) : null;
    var form = section ? $('[data-eg-loc-form]', section) : null;
    var openPanel = null, openBtn = null, hoverTimer = null, lastY = window.scrollY || 0, ticking = false;

    /* ---------- desplegables y ventanas ---------- */
    function setOpen(btn, panel, open) {
      if (open && openPanel && openPanel !== panel) setOpen(openBtn, openPanel, false);
      panel.dataset.open = open ? 'true' : 'false';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { openPanel = panel; openBtn = btn; }
      else if (openPanel === panel) { openPanel = null; openBtn = null; }
      header.classList.toggle('is-open', !!openPanel);
      if (open) header.classList.remove('is-hidden');
    }
    function closeAll() { if (openPanel) setOpen(openBtn, openPanel, false); }

    $$('[data-eg-menu]', header).forEach(function (item) {
      var btn = $('.eg-hdr__link', item), panel = $('.eg-mega', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        clearTimeout(hoverTimer);
        if (panel.dataset.open === 'true' && panel.dataset.hover === '1') { delete panel.dataset.hover; return; } // abierto por hover: el clic lo deja abierto
        setOpen(btn, panel, panel.dataset.open !== 'true');
      });
      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { if (panel.dataset.open !== 'true') { setOpen(btn, panel, true); panel.dataset.hover = '1'; } }, HOVER_IN);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { delete panel.dataset.hover; if (openPanel === panel) setOpen(btn, panel, false); }, HOVER_OUT);
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(btn, panel, false);
      });
    });

    $$('[data-eg-loc]', header).forEach(function (loc) {
      var btn = $('.eg-loc__btn', loc), panel = $('.eg-pop', loc);
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(btn, panel, panel.dataset.open !== 'true'); });
      loc.addEventListener('focusout', function (e) {
        if (!loc.contains(e.relatedTarget)) setOpen(btn, panel, false);
      });
    });

    document.addEventListener('click', function (e) {
      if (openPanel && !e.target.closest('[data-eg-menu], [data-eg-loc]')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openPanel) { var b = openBtn; closeAll(); if (b) b.focus(); }
      if (drawer && drawer.dataset.open === 'true') closeDrawer();
    });

    /* ---------- cajón móvil ---------- */
    var burger = $('[data-eg-drawer-open]', header), lastFocus = null;
    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.dataset.open = 'true';
      document.documentElement.classList.add('eg-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var close = $('[data-eg-drawer-close]:not(.eg-drawer__scrim)', drawer);
      if (close) close.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      document.documentElement.classList.remove('eg-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      $$('[data-eg-drawer-close]', drawer).forEach(function (el) { el.addEventListener('click', closeDrawer); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', drawer).filter(function (el) { return el.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      window.matchMedia('(min-width: 1000px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
    }

    /* ---------- país e idioma ---------- */
    function submitLocalization(kind, value) {
      if (!form) return;
      var input = $('[data-eg-loc-input="' + kind + '"]', form);
      if (!input) return;
      input.value = value;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
    (section || header).addEventListener('click', function (e) {
      var c = e.target.closest('[data-eg-loc-country]');
      if (c) { e.preventDefault(); submitLocalization('country', c.getAttribute('data-eg-loc-country')); return; }
      var l = e.target.closest('[data-eg-loc-language]');
      if (l) { e.preventDefault(); submitLocalization('language', l.getAttribute('data-eg-loc-language')); }
    });

    /* ---------- desplazamiento ---------- */
    var hideOnScroll = header.hasAttribute('data-hide-on-scroll'), anchoring = false, anchorTimer = null;
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
      var dy = y - lastY;
      header.classList.toggle('is-scrolled', y > SCROLL_ON);
      if (anchoring) { header.classList.remove('is-hidden'); lastY = y; setOffset(); return; } // salto a un ancla en curso
      if (hideOnScroll) {
        if (y > HIDE_AFTER && dy > DELTA && !openPanel) header.classList.add('is-hidden');
        else if (dy < -DELTA || y <= HIDE_AFTER) header.classList.remove('is-hidden');
      }
      if (Math.abs(dy) > DELTA || y <= HIDE_AFTER) lastY = y;
      setOffset();
    }
    /* --eg-hdr-offset: altura visible de la cabecera, para barras secundarias fijas (navegación de producto) */
    function setOffset() {
      var h = header.classList.contains('is-hidden') ? 0 : header.offsetHeight;
      document.documentElement.style.setProperty('--eg-hdr-offset', h + 'px');
    }
    window.addEventListener('resize', setOffset);
    function onScroll() { if (anchoring) settle(); if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    header.addEventListener('mouseenter', function () { header.classList.remove('is-hidden'); setOffset(); });
    /* Salto a un ancla (#como-funciona), con scroll suave: la cabecera se mantiene visible hasta que el desplazamiento
       termina (scroll-padding-top ya le reserva sitio) */
    function settle() { clearTimeout(anchorTimer); anchorTimer = setTimeout(function () { anchoring = false; header.classList.remove('is-hidden'); lastY = window.scrollY || 0; setOffset(); }, 200); }
    function anchor() { anchoring = true; header.classList.remove('is-hidden'); setOffset(); settle(); }
    window.addEventListener('hashchange', anchor);
    if (location.hash) { anchoring = true; window.addEventListener('load', settle); settle(); }
    lastY = window.scrollY || 0;
    update();
  }

  function boot() { $$('[data-eg-header]').forEach(initHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-eg-header]', e.target).forEach(function (h) { delete h.dataset.egReady; initHeader(h); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('[data-eg-menu]');
    var btn = item && item.querySelector('.eg-hdr__link');
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target && e.target.closest && e.target.closest('[data-eg-menu]');
    var btn = item && item.querySelector('.eg-hdr__link');
    if (btn && btn.getAttribute('aria-expanded') === 'true') btn.click();
  });
})();
